
            <div class="radio-group">
                <input appPlaySound [type]="inputType" [required]="true" [checked]="isChecked()" [id]="id" (change)="toggleCheck()"/>
                <label [for]="id">{{value}}</label>
            </div>
        <ng-content></ng-content>
    